import type { PlaceOrderFormData } from './placeOrderTypes.js';
import type { AddonProductOfferingWithSelection } from '../../common/types/productOfferings.js';
import type { ProductOfferingCartItems } from '../../common/types/shoppingBasketCoCo.js';

export interface ShoppingBasketUpdateMethodsCoCo {
  changeQuantity: (newQty: number, groupItems: ProductOfferingCartItems[]) => void;
  updateProductAddons?: (addonId: string, groupCartItemIds: string[]) => void;
  updateAddonGroupSelection?: (groupId: string, selectedOfferingIds: string[], groupCartItemIds: string[]) => void;
  updateProductOfferingRuntimeCharacteristic?: (groupCartItemIds: string[], selectedValue: string) => void;
  updatePlanProductOfferingSpecRuntimeCharacteristic?: (cartItemId: string, selectedValue: string) => void;
}

export interface CheckoutStepValidationHandleCoCo {
  validate: () => boolean | Promise<boolean>;
}

export type SimTypeCoCo = 'PHYSICAL' | 'PHYSICAL_MINI_MICRO' | 'PHYSICAL_NANO' | 'ESIM';

// eslint-disable-next-line no-redeclare
export const SimTypeCoCo = {
  PHYSICAL: 'PHYSICAL' as SimTypeCoCo,
  PHYSICAL_MINI_MICRO: 'PHYSICAL_MINI_MICRO' as SimTypeCoCo,
  PHYSICAL_NANO: 'PHYSICAL_NANO' as SimTypeCoCo,
  ESIM: 'ESIM' as SimTypeCoCo,
};

export type NumberPortingCoCo = 'NEW_NUMBER' | 'PORT_IN';

export interface PlaceOrderItemUnitCoCo {
  basketItemId: string;
  basketItemIndex: number;
  purposeOfUse?: string;
  userContact?: string;
  installationContact?: string;
  simType?: SimTypeCoCo;
  simCardNumber?: string;
  directoryListingPublicity?: string;
  directoryListingCustomPublicityDetails?: NumberPublicityAddressDetailsCoCo;
  mobileNumber?: string;
  numberPorting?: NumberPortingCoCo;
  differentDonor?: boolean;
  donorEmail?: string;
  fixedTermContract?: boolean;
  portInDate?: number;
  additionalParameters?: Record<string, string>;
  costCenter?: string;
  subscriptionReference?: string;
  enrollmentProgram?: string;
  enrollmentAlias?: string;
  enrollmentCustomerId?: string;
  deviceEnrollment?: string;
  productOfferAddons?: AddonProductOfferingWithSelection[];
  addonRuntimeCharacteristics?: Record<string, Record<string, string>>;
}

export interface PlaceOrderFormDataCoCo extends Omit<PlaceOrderFormData, 'products'> {
  products: {
    placeOrderItemUnits: PlaceOrderItemUnitCoCo[];
    preferredInstallationDate?: string;
    installationAppointmentTimeSlotIds?: Record<string, string>;
  };
}

export interface NumberPublicityAddressDetailsCoCo {
  companyName?: string;
  recipientName?: string;
  address?: {
    line?: string;
    postalCode?: string;
    postOffice?: string;
  };
}
